import Server from "./Server";
import SystemFunctions from "./SystemFunctions";
import TimeLogic from "./TimeLogic";

export default class SData {

    static base = null;
    static currentTask = null;
    static tasks = null;

    static lastResponseBase = null;
    static lastResponseTasks = null;
    static tasks_lastUpdate = 0;
    static listeners = [];

    static TYPE_BASE = 'base';
    static TYPE_TASKS = 'tasks';

    static updateBase(onUpdate = (status, data) => {
    }) {
        Server.query(Server.QUERY_GET_DATA, {}, (response) => {
            let r = response.data;
            if (r.status) {
                TimeLogic.updateOffset(r.base.time, r.base.timezone);
                delete r.base.time;
                let jsonR = JSON.stringify(r);
                let isNewData = jsonR !== this.lastResponseBase;
                this.lastResponseBase = jsonR;
                this.base = r.base;
                this.currentTask = r.currentTask;

                if (this.base.purpose != null && (this.tasks == null || this.base.purpose.last_update > this.tasks_lastUpdate)) {
                    this.tasks_lastUpdate = this.base.purpose.last_update;
                    this.updateTasks(() => onUpdate(true, response, isNewData));
                } else {
                    onUpdate(true, response, isNewData);
                }
                this.callListeners(this.TYPE_BASE, isNewData);
            } else {
                onUpdate(false, {
                    status: -r.code,
                    message: r.error,
                }, null);
            }
        }, (error) => {
            onUpdate(false, error, null);
        });
    }

    static updateTasks(onUpdate = (status, data) => {
    }) {
        console.log('tasks sync');
        Server.query(Server.QUERY_TASKS, {a: 'get'}, (response) => {
            let r = response.data;

            if (r.status) {
                this.tasks = r.tasks;
                onUpdate(true, response, true);
                this.callListeners(this.TYPE_TASKS, true);
            } else {
                onUpdate(false, {
                    status: -r.code,
                    message: r.error,
                }, null);
            }
        }, (error) => {
            onUpdate(false, error, null);
        });
    }

    static setFromServerBase(serverBase) {
        if (serverBase == null) {
            return false;
        }
        this.base = SystemFunctions.cloneObj(serverBase);
        this.callListeners(this.TYPE_BASE);
        return true;
    }

    static setFromServerCurrentTasks(currentTask) {
        if (currentTask == null) {
            return false;
        }
        this.currentTask = SystemFunctions.cloneObj(currentTask);
        return true;
    }

    static setFromServerTasks(serverTasks) {
        if (serverTasks == null) {
            return false;
        }
        this.tasks = SystemFunctions.cloneObj(serverTasks);
        if(this.base.purpose != null){
            this.tasks_lastUpdate = this.base?.purpose?.last_update;
        }
        this.callListeners(this.TYPE_TASKS);
        return true;
    }

    static callListeners(type, isNewData){
        for (let i = 0; i < this.listeners.length; i++) {
            let c = this.listeners[i];
            if (c != null && typeof c === 'function'){
                c(type, isNewData);
            }
        }
    }

    static setListener(callback) {
        return this.listeners.push(callback) - 1;
    }

    static removeListener(id) {
        return this.listeners.splice(id, 1);
    }
}
